{
  "SLA": {
    "HEADER": "Acordo de Nível de Serviço",
    "ADD_ACTION": "Adicionar SLA",
    "ADD_ACTION_LONG": "Criar uma nova Política de SLA",
    "DESCRIPTION": "Acordo de Nível de Serviço (SLAs em inglês) são acordos que definem expectativas claras entre seu time e os clientes. Estabelecem normas para tempos de resposta e de resolução, criando um quadro de responsabilização e garantindo uma experiência coerente e de qualidade.",
    "LEARN_MORE": "Saiba mais sobre SLA",
    "COUNT": "{n} SLA | {n} SLAs",
    "LOADING": "Buscando SLAs",
    "SEARCH_PLACEHOLDER": "Pesquisar SLA...",
    "SEARCH": {
      "NO_RESULTS": "Nenhuma SLA encontrada correspondente à sua busca"
    },
    "PAYWALL": {
      "TITLE": "Atualize para criar SLAs",
      "AVAILABLE_ON": "O recurso SLA está disponível apenas nos planos Business e Enterprise.",
      "UPGRADE_PROMPT": "Atualize seu plano para obter acesso a recursos avançados como gerenciamento de time, automações, atributos personalizados e muito mais.",
      "UPGRADE_NOW": "Atualizar agora",
      "CANCEL_ANYTIME": "Você pode alterar ou cancelar seu plano a qualquer momento"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "O recurso SLA está disponível apenas nos planos pagos.",
      "UPGRADE_PROMPT": "Atualize para um plano pago para acessar recursos avançados como logs de auditoria, capacidade do agente e muito mais.",
      "ASK_ADMIN": "Entre em contato com seu administrador para fazer a atualização."
    },
    "LIST": {
      "404": "Não há SLAs disponíveis nesta conta.",
      "TABLE_HEADER": {
        "SLA": "SLA",
        "BUSINESS_HOURS": "Horário comercial"
      },
      "EMPTY": {
        "TITLE_1": "Enterprise P0",
        "DESC_1": "Questões levantadas por clientes empresariais que requerem atenção imediata.",
        "TITLE_2": "Enterprise P1",
        "DESC_2": "Questões levantadas por clientes empresariais que precisam ser reconhecidas rapidamente."
      },
      "BUSINESS_HOURS_ON": "Ativado",
      "BUSINESS_HOURS_OFF": "Desativado",
      "RESPONSE_TYPES": {
        "FRT": "Próximo limite de tempo de resposta",
        "NRT": "Próximo limite de tempo de resposta",
        "RT": "Limite de tempo de resolução",
        "SHORT_HAND": {
          "FRT": "FRT",
          "NRT": "NRT",
          "RT": "RT"
        }
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nome da SLA",
        "PLACEHOLDER": "Nome da SLA",
        "REQUIRED_ERROR": "Nome da SLA é obrigatória",
        "MINIMUM_LENGTH_ERROR": "Tamanho mínimo 2 é necessário",
        "VALID_ERROR": "Somente Letras, Números, Hífen e Sublinhado são permitidos"
      },
      "DESCRIPTION": {
        "LABEL": "Descrição",
        "PLACEHOLDER": "SLA para clientes premium"
      },
      "FIRST_RESPONSE_TIME": {
        "LABEL": "Tempo de Primeira Resposta",
        "PLACEHOLDER": "5"
      },
      "NEXT_RESPONSE_TIME": {
        "LABEL": "Próximo Tempo de Resposta",
        "PLACEHOLDER": "5"
      },
      "RESOLUTION_TIME": {
        "LABEL": "Tempo de Resolução",
        "PLACEHOLDER": "60"
      },
      "BUSINESS_HOURS": {
        "LABEL": "Horário de funcionamento",
        "PLACEHOLDER": "Apenas durante o horário comercial"
      },
      "THRESHOLD_TIME": {
        "INVALID_FORMAT_ERROR": "O limite deve ser um número e maior que zero"
      },
      "EDIT": "Alterar",
      "CREATE": "Criar",
      "DELETE": "Excluir",
      "CANCEL": "Cancelar"
    },
    "ADD": {
      "TITLE": "Adicionar SLA",
      "DESC": "Promessas amigáveis ​​para um ótimo serviço!",
      "API": {
        "SUCCESS_MESSAGE": "SLA adicionada com sucesso",
        "ERROR_MESSAGE": "Ocorreu um erro, por favor tente novamente"
      }
    },
    "DELETE": {
      "TITLE": "Excluir SLA",
      "API": {
        "SUCCESS_MESSAGE": "SLA excluído com sucesso",
        "ERROR_MESSAGE": "Ocorreu um erro, por favor tente novamente"
      },
      "CONFIRM": {
        "TITLE": "Confirmar exclusão",
        "MESSAGE": "Tem certeza que deseja excluir ",
        "YES": "Sim, excluir ",
        "NO": "Não, Mantenha "
      }
    },
    "EVENTS": {
      "TITLE": "Faltas de SLA",
      "FRT": "Primeira resposta",
      "NRT": "Próximo tempo de resposta",
      "RT": "Tempo de resolução",
      "SHOW_MORE": "{count} mais",
      "HIDE": "Ocultar {count} linhas"
    }
  }
}
